import { notification } from 'antd';
import { useEffect, useState } from 'react';

import apiDatalake from '../../../../services/apiDatalake';

const useCardData = ({ clientes }) => {
  const [cardData, setCardData] = useState([]);
  const [loadingCardData, setLoadingCardData] = useState(false);

  useEffect(() => {
    const getCardData = async () => {
      if (!clientes) {
        return;
      }

      setLoadingCardData(true);
      try {
        const { data } = await apiDatalake.post(
          'buscar-quantidade-transportadores-shipper',
          {
            cpf_cnpj_cliente: clientes,
          }
        );

        setCardData({
          transportadorasTotal: data?.qtd_transportadores_total,
          transportadorasAtivas: data?.qtd_transportadores_ativos,
          transportadorasInativas: data?.qtd_transportadores_inativos,
        });
      } catch {
        notification.error({
          message: 'Não foi possível obter os dados das transportadoras',
          description: 'Tente novamente ou entre em contato com o suporte',
        });
      }
      setLoadingCardData(false);
    };
    getCardData();
  }, [clientes]);

  return {
    cardData,
    loadingCardData,
  };
};

export default useCardData;
